import { PathsPostsV1ExploreGetParametersQuerySort } from '@repo/api-client';
import IconClock from '@repo/ui-icons/IconClock';
import IconFire from '@repo/ui-icons/IconFire';
import IconStarOutlined from '@repo/ui-icons/IconStarOutlined';
import IconTrophy from '@repo/ui-icons/IconTrophy';

export const SWIMLANES_TO_SHOW = [
  {
    name: 'For You',
    urlSlug: 'for-you',
    title: 'Smart Picks for You',
    subTitle:
      'Templates inspired by what you’ve liked and used, plus favorites from designers who share your creative edge.',
    icon: IconStarOutlined,
    apiConfig: {
      method: '/posts/for-you',
      params: {},
    },
    swimlaneFeatureScope: 'forYouSwimlaneFeed',
    detailedPageScope: 'forYouDetailedPage',
  },
  {
    name: 'Weekly Staff Picks',
    urlSlug: 'staff-picks',
    title: 'Handpicked by Kittl',
    subTitle:
      'Weekly picks of designs, curated by the Kittl team to inspire your next creation.',
    icon: IconTrophy,
    apiConfig: {
      method: '/posts/staff-picks',
      params: {},
    },
    swimlaneFeatureScope: 'staffPicksSwimlaneFeed',
    detailedPageScope: 'staffPicksDetailedPage',
  },
  {
    name: 'Trending Now',
    urlSlug: 'trending-now',
    title: 'Popular in the Community',
    subTitle:
      'Templates that sparked countless remixes, collabs, and creative spins, shaped by the collective talent of the Kittl community.',
    icon: IconFire,
    apiConfig: {
      method: '/posts/v1/explore',
      params: { sort: PathsPostsV1ExploreGetParametersQuerySort.trending },
    },
    swimlaneFeatureScope: 'trendingNowSwimlaneFeed',
    detailedPageScope: 'trendingNowDetailedPage',
  },
  {
    name: 'Seasonal Highlights',
    urlSlug: 'seasonal-highlights',
    title: 'In Season Now',
    subTitle:
      'Stay ahead of the season with templates made for upcoming holidays, events, and everything worth celebrating.',
    icon: IconClock,
    apiConfig: {
      method: '/posts/upcoming-events',
      params: {},
    },
    swimlaneFeatureScope: 'seasonalHighlightsSwimlaneFeed',
    detailedPageScope: 'seasonalHighlightsDetailedPage',
  },
] as const;
